import React, { Fragment, JSX, Ref } from 'react';
// import './styles.css';
// import { Modal } from '@/components/modal';
import { Loader } from '@aws-amplify/ui-react';
import { CameraSize } from '../../types/index';

interface StateProps {
  loading: boolean;
  message?: string;
  cameraSize?: CameraSize;
  videoRef?: Ref<HTMLVideoElement>;
  canvasRef?: Ref<HTMLCanvasElement>;
  imageBase64?: string;
  isMobile: boolean;
}

export const CheckContainer: React.FC<StateProps> = ({
  loading,
  message,
  cameraSize,
  videoRef,
  canvasRef,
  imageBase64,
  isMobile,
}): JSX.Element => {
  const containerClasses = isMobile
    ? 'relative w-full max-w-[420px] mx-auto font-dmsans'
    : 'relative w-full max-w-[520px] mx-auto font-dmsans';

  return (
    <Fragment>
      <div className={containerClasses}>
        {message && (
          <div
            className={
              isMobile
                ? 'absolute top-0 w-full z-50 px-4 pt-[calc(env(safe-area-inset-top)+12px)] pb-3 text-center bg-white '
                : 'absolute top-0 left-0 w-full z-50 px-6 py-4 text-center bg-white  rounded-t-md'
            }
          >
            {loading && <Loader />}

            <span
              className={
                isMobile ? 'text-xl font-semibold text-black' : 'text-2xl font-semibold text-black'
              }
            >
              {message}
            </span>
          </div>
        )}

        {imageBase64 && <img src={imageBase64} />}

        {cameraSize && !imageBase64 && (
          <div
            className={
              isMobile
                ? 'relative w-full max-w-[420px] mx-auto aspect-[9/16] overflow-hidden bg-black'
                : 'mt-[64px] w-full aspect-[3/4] overflow-hidden bg-black rounded-b-md'
            }
          >
            <video
              ref={videoRef}
              id="webcam"
              autoPlay
              muted
              playsInline
              className={isMobile ? 'h-full w-full object-cover' : 'h-full w-full object-cover'}
              style={{
                transform: 'scaleX(-1)',
              }}
              // width={cameraSize.width}
              // height={cameraSize.height}
            />
            <canvas
              ref={canvasRef}
              // width={cameraSize.width}
              // height={cameraSize.height}
              className="absolute inset-0 h-full w-full"
              style={{
                transform: 'scaleX(-1)',
              }}
              // style={{
              //   position: 'absolute',
              //   top: 0,
              //   left: 0,
              //   transform: 'scaleX(-1)',
              // }}
            />
          </div>
        )}
        {/*
    <Modal visible={message !== undefined}>
      <div>
        <label className="text-3xl text-red-600/100">{message}</label>
      </div>
    </Modal>
     */}
      </div>
    </Fragment>
  );
};
